

export class UrlState {

    listeners: any[];
    public hashChanged: any;
    hash: string;

    constructor() {

        this.listeners = [];

        this.hashChanged = (event, hash: string = null) => {

            this.hash = hash? hash.replace('#', '') : window.location.hash.replace('#', '');
            if(this.hash != '') {
                this.listeners.forEach(listener => {
                    listener.hashStateChanged(this.hash);
                });
            }
        };

        window.onhashchange = this.hashChanged;
        this.hashChanged();
    }


    public registerListener(listener: any) {

        this.listeners.push(listener);
        if (this.hash !== '') {
            listener.hashStateChanged(this.hash);

        }

    }

}
